export default __webpack_public_path__ + "assets/images/Landing_page_img2.e90d1ae9.svg";